const getterEditorModePPT = (state) => {
  return state.isEnableAddinPowerpoint && state.isPPTEditMode
}

export default {
  getterEditorModePPT,
}
